export default "__VITE_ASSET__Bx0ei6CD__"